module.exports = __webpack_public_path__ + "media/images/emblems/Mont_Tramelan-coat_of_arms-f4656224c2c2abc7de536dd0e4609a6f.svg";